import { FC } from "react"
import * as Cesium from "cesium"
import './GroundTargetCard.css'
import { truncateAltitude, truncateNumber } from "../../utils/commonFunctions";
import { LatLongSvg, NewAltitudeSvg } from "./svgs/Svgs";

interface GsProps {
    target: any;
    viewer: any
}
const GroundTargetCard: FC<GsProps> = ({ target, viewer }) => {
    if (target && viewer) {
        let targetName = target?.name ?? target?.groundTargetName;
        let targetLong = target?.longitude ?? target?.position?.[0] ?? target?.coordinates?.['long'];
        let targetLat = target?.latitude ?? target?.position?.[1] ?? target?.coordinates?.['lat'];
        let target_altitude = target?.altitude ?? target?.position?.[2] ?? target?.coordinates?.['altitude'];
        var cartographic = Cesium.Cartographic.fromDegrees(targetLong, targetLat);
        var cartesianPosition = Cesium.Cartographic.toCartesian(cartographic);
        const popupPosition = Cesium.SceneTransforms.wgs84ToWindowCoordinates(
            viewer.scene,
            cartesianPosition
        );

        let outside_window_x = (popupPosition.x + (410)) > window.innerWidth;
        let top = `${popupPosition.y}px`;
        let left = outside_window_x ? `${popupPosition.x - (410)}px` : `${popupPosition.x + 10}px`;

        return (
            <div className="popup-modal"
                key={target?.['groundTargetId']}
                style={{
                    display: 'flex',
                    flexDirection: "row",
                    alignContent: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    left: left,
                    top: top,
                    transition: 'all 0.3s ease',
                    padding: '8pt',
                    width: '300pt',
                }}>
                <div className='d-flex align-items-start flex-column geofeatureTitle'>
                    <div className='d-flex align-items-center w-100'>
                        <span className='fs-14 w-100 color-F0F0F0 text-truncate' title={targetName}>
                            {targetName}
                        </span>

                    </div>
                    <span className='fs-12 color_history text-truncate'>
                        GeoFeature
                    </span>
                </div>
                <div className='align-items-center justify-content-center gap-2 d-flex show__position fs-12'>
                    <div className="d-flex align-items-center gap-2 ">
                        <LatLongSvg />
                        <span>{!targetLat ? 'NA' : truncateNumber(targetLat, 2)}{'\u00B0'}, {!targetLong ? 'NA' : truncateNumber(targetLong, 2)}{'\u00B0'}</span>
                    </div>
                    <div className="d-flex gap-1">
                        <div className="d-flex align-items-center">
                            <NewAltitudeSvg />
                        </div>
                        <span>{!target_altitude ? 'NA' : truncateAltitude(target_altitude) + ' km'}</span>
                    </div>
                </div>
            </div >
        )


    }
    return null
}

export default GroundTargetCard